import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../../config';
import { useAuth } from '../../hooks/useAuth';

function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const { accessToken: token } = useAuth();

  useEffect(() => {
    fetch(`${API_URL}/admin/stats`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => {
        setStats(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="loading">Chargement...</div>;
  if (!stats) return <div className="error">Erreur de chargement</div>;

  return (
    <div>
      <div className="admin-page-header">
        <h2>Tableau de bord</h2>
        <p>Vue d'ensemble de la plateforme Darna Immo</p>
      </div>

      <div className="admin-stats">
        <div className="admin-stat-card glass-card">
          <div className="admin-stat-icon">👥</div>
          <div className="admin-stat-value">{stats.users.total}</div>
          <div className="admin-stat-label">Utilisateurs</div>
          <div className="admin-stat-sub">+{stats.users.nouveauxMois} ce mois</div>
        </div>

        <div className="admin-stat-card glass-card">
          <div className="admin-stat-icon">🏠</div>
          <div className="admin-stat-value">{stats.annonces.actives}</div>
          <div className="admin-stat-label">Annonces actives</div>
          <div className="admin-stat-sub">{stats.annonces.total} total</div>
        </div>

        <div className="admin-stat-card glass-card">
          <div className="admin-stat-icon">⏳</div>
          <div className="admin-stat-value">{stats.annonces.enAttente}</div>
          <div className="admin-stat-label">En attente</div>
          <div className="admin-stat-sub">A moderer</div>
        </div>

        <div className="admin-stat-card glass-card">
          <div className="admin-stat-icon">✅</div>
          <div className="admin-stat-value">{stats.verifications.enAttente}</div>
          <div className="admin-stat-label">Certifications</div>
          <div className="admin-stat-sub">En attente</div>
        </div>
      </div>

      {/* Roles breakdown */}
      <div className="glass-card" style={{padding: '1.2rem', marginBottom: '1.5rem'}}>
        <h3 style={{fontSize: '1rem', marginBottom: '0.8rem', color: 'var(--text)'}}>Repartition des roles</h3>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
          {Object.entries(stats.users.parRole).map(([role, count]) => (
            <div key={role} style={{display: 'flex', alignItems: 'center', gap: '0.4rem'}}>
              <span className={`badge badge-${role}`}>{role}</span>
              <span style={{fontWeight: 600, color: 'var(--text)'}}>{count}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Quick actions */}
      <div className="glass-card" style={{padding: '1.2rem'}}>
        <h3 style={{fontSize: '1rem', marginBottom: '0.8rem', color: 'var(--text)'}}>Actions rapides</h3>
        <div className="admin-quick-actions">
          {stats.annonces.enAttente > 0 && (
            <Link to="/admin/annonces" className="btn btn-primary">
              Moderer {stats.annonces.enAttente} annonce{stats.annonces.enAttente > 1 ? 's' : ''}
            </Link>
          )}
          {stats.verifications.enAttente > 0 && (
            <Link to="/admin/verifications" className="btn btn-secondary">
              {stats.verifications.enAttente} certification{stats.verifications.enAttente > 1 ? 's' : ''} en attente
            </Link>
          )}
          <Link to="/admin/users" className="btn" style={{background: 'var(--bg-input)', color: 'var(--text)'}}>
            Gerer les utilisateurs
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
